import React from 'react';
import { useISOReportsTable } from '../../lib';
import { DateSelect } from '@shared/UI';
import './ISOReportsTableFilters.scss';
import { RadioFilter } from '@features/RadioFilter';
import { formats } from '@shared/utils';

export const ISOReportsTableFilters: React.FC = () => {
    const { date, isoReportsType, setISOReportsType, setDate } = useISOReportsTable();

    return (
        <div className='widget-iso-reports-table-filters'>
            <DateSelect
                currentValue={date}
                format={formats.dateWithYear}
                allowClear
                placeholder='File Date'
                onDateSelect={(date) => setDate(date)}
            />
            <RadioFilter
                options={[
                    { label: 'Intraday', value: 'current' },
                    { label: 'Business Day', value: 'previous' },
                ]}
                value={isoReportsType}
                setValue={setISOReportsType}
                name={'reportsType'}
                initialOption={isoReportsType}
                className='widget-iso-reports-table-filters__radio-filter'
            />
        </div>
    );
};
